<script lang="ts">
    import Modal from "../Modal/Modal.svelte";
    import {ApiCall} from "../../services/ApiCall.ts";
    import {push} from "svelte-spa-router";

    let promise = makeApiCall();

    async function makeApiCall() {

        const apiCall = new ApiCall();

        try{
            const content = await apiCall.authenticatedPostRequest('applicateur/get_history', null);

            if (content.success === false) {
                push('/erreur500')
            }
            else{
                content.data.forEach(element =>
                    element['created_at'] = new Date(element['created_at']).toLocaleString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'})
                );

                return content.data;
            }
        }
        catch (e) {
            push('/erreur500')
        }
    }
</script>

<h2 class="title is-2 has-text-centered mb-6">Mes commandes</h2>

{#await promise}
    <Modal title="Chargement des commandes" type="loader"/>
{:then allOrder}
    {#if allOrder.length > 0}
        {#each allOrder as {reference, created_at, ref_chantier, address, address_supplement, postal_code, city, planning, chape, fibree, longueur_tuyaux_chape, longueur_tuyaux_eau, plancher, cubage}}
            <div class="box mb-6">
                <div class="box-header is-flex-desktop is-justify-content-space-between">
                    <p class="has-text-weight-bold">Commande : {reference}</p>
                    <em>Réalisée : {created_at}</em>
                </div>
                <div>
                    <p>Référence du chantier : {ref_chantier !== null ? ref_chantier : ''}</p>
                </div>
                <hr>
                <div class="box-content">
                    <div class="is-flex-desktop is-justify-content-space-between columns is-desktop">
                        <p class="column"><strong>Adresse de livraison :</strong> {address !== null ? address : ''}</p>
                        <p class="column"><strong>Complément d'adresse:</strong> {address_supplement !== null ? address_supplement : ''}</p>
                    </div>
                    <div class="is-flex-desktop is-justify-content-space-between columns is-desktop">
                        <p class="column"><strong>Code postal :</strong> {postal_code !== null ? postal_code : ''}</p>
                        <p class="column"><strong>Ville :</strong> {city}</p>
                    </div>
                </div>
                <hr>
                <div class="box-footer">
                    <div class="is-flex-desktop is-justify-content-space-between columns is-desktop">
                        <p class="column"><strong>Heure et date de livraison souhaitée :</strong> {new Date(planning).toLocaleString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'})}</p>
                    </div>
                    <div class="is-flex-desktop is-justify-content-space-between columns is-desktop">
                        <p class="column"><strong>Chape :</strong> {chape}</p>
                        <p class="column"><strong>Fibrée :</strong> {fibree === 1 ? 'Oui' : 'Non'}</p>
                    </div>
                    <div class="is-flex-desktop is-justify-content-space-between columns is-desktop">
                        <p class="column"><strong>Longueur de tuyaux pour la chape :</strong> {longueur_tuyaux_chape !== null ? longueur_tuyaux_chape : ''} ml</p>
                        <p class="column"><strong>Longueur de tuyaux d'eau :</strong> {longueur_tuyaux_eau !== null ? longueur_tuyaux_eau : ''} ml</p>
                    </div>
                    <div class="is-flex-desktop is-justify-content-space-between columns is-desktop">
                        <p class="column"><strong>Type de plancher :</strong> {plancher}</p>
                        <p class="column"><strong>Cubage commandé :</strong> {cubage} m²</p>
                    </div>
                </div>
            </div>
        {:else}
            <Modal title="Chargement des commandes">
                <svelte:fragment slot="content">
                    <div class="dots6">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </svelte:fragment>
            </Modal>
        {/each}
    {:else }
        <div class="box">
            <div class="box-header is-flex is-justify-content-center">
                <p>Vous retrouverez prochainement vos commandes ici.</p>
            </div>
        </div>
    {/if}
{/await}